export enum InboxMessageTitles {
  PluginLoaded = "plugin_loaded",
  PluginInited = "plugin_inited",
  CustomerDetailsSection = "customer_details_section",
  PutMessage = "put_message",
  SetFullscreenWidgetNotificationBadge = "set_fullscreen_widget_notification_badge",
}
